import { injectable } from 'inversify'
import { LocalStorageServiceBase } from '@/services/storage/localStorageServiceBase'
import type { LocalStorageServiceInterface } from '@/services/storage/types'

@injectable()
export class LocalStorageService extends LocalStorageServiceBase implements LocalStorageServiceInterface {
  protected readonly storage = localStorage
}
